const colors = [
    "#92C5F9", // light blue
    "#FFF4D9", // light yellow
    "#A8D0C6", // light green
    "#F7D9EE", // light purple
    "#313A5C", // dark blue
    "#365F73", // dark green
    "#C8D9C1", // light green
    "#F5921B", // orange
    "#707070", // gray
];

function getRandomElements(arr, n) {
    const shuffled = arr.slice();
    let i = arr.length, temp, randomIndex;

    while (i--) {
        randomIndex = Math.floor(Math.random() * (i + 1));
        temp = shuffled[i];
        shuffled[i] = shuffled[randomIndex];
        shuffled[randomIndex] = temp;
    }

    return shuffled.slice(0, n);
}

export const formatPieChartData = (pieChartData, title) => {
    return {
        labels: Object.keys(pieChartData),
        values: Object.values(pieChartData),
        colors: getRandomElements(colors, Object.keys(pieChartData).length),
        title: title,
    }
};


export const formatBarChartData = (barGraphData, title) => {
    return {
        labels: Object.keys(barGraphData),
        values: Object.values(barGraphData),
        colors: getRandomElements(colors, Object.keys(barGraphData).length),
        title: title,
    }
}

const formatTableData = (lineGraphData) => {
    const daysOfWeek = Object.keys(lineGraphData);
    const tableData = daysOfWeek.map(day => {
        const hourlyData = lineGraphData[day];
        const row = {
            day: day,
            hourlyValues: hourlyData,
        };
        return row;
    });
    return tableData;
}

const formatLineChartData = (lineGraphData) => {
    const daysOfWeek = Object.keys(lineGraphData);
    const borderColors = ['#707070', '#D15F5F', '#5A7DFF', '#6B8E23', '#E3C16F', '#9B6AB5', '#7F4C32', '#66CDAA', '#E06C75', '#8B5F9E', '#48C9B0', '#D8A1F2', '#F5C59F'];

    const formattedData = {
        title: "Hourly Transaction Comparison by Week",
        xLabel: "Hour of the day",
        yLabel: "Number of Transactions",
        labels: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')),
        datasets: daysOfWeek.map((day, i) => ({
            label: day,
            data: lineGraphData[day],
            borderColor: borderColors[i % borderColors.length],
            fill: false,
        })),
    };

    return formattedData;
}

const formatDataGateCount = (lineGraphData) => {
    const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const dayNames = {
        "Mon": "Monday",
        "Tue": "Tuesday",
        "Wed": "Wednesday",
        "Thu": "Thursday",
        "Fri": "Friday",
        "Sat": "Saturday",
        "Sun": "Sunday"
    };

    const borderColors = ['#707070', '#D15F5F', '#5A7DFF', '#6B8E23', '#E3C16F', '#9B6AB5'];

    const labels = Array.from({ length: 16 }, (_, i) => `${i + 9}`);

    const formattedData = {
        title: "Hourly Gate Entry Comparison by Day",
        xLabel: "Hour of the day",
        yLabel: "Number of Visitors",
        labels: labels,
        datasets: daysOfWeek.map((day, i) => {
            const dayData = lineGraphData[day];

            return {
                label: dayNames[day],
                data: dayData,
                borderColor: borderColors[i % borderColors.length],
                fill: false,
            };
        }),
    };

    return formattedData;
}

// 🆕 For month-based line charts (Bookings per Month, Hours per Month)
export const formatMonthLineChartData = (lineGraphData, title) => {
    const labels = Object.keys(lineGraphData); // e.g., ["2024-01", "2024-02", "2024-03"]
    const values = Object.values(lineGraphData);

    return {
        labels,
        datasets: [{
            label: title,
            data: values,
            borderColor: '#5A7DFF',
            fill: false,
        }],
        title: title,
    };
};

export const formatData = (data) => {
    return {
        ...data,
        pieChartData: formatPieChartData(data.pieChartData, 'Transaction Type Distribution View'),
        barGraphData: formatBarChartData(data.barGraphData),
        tableData: formatTableData(data.lineGraphData),
        lineGraphData: formatLineChartData(data.lineGraphData),
        gateCountLineGraph: formatDataGateCount(data.gateCountLineGraph),
    };
};